import { ja } from 'vuetify/lib/locale'

export default {
  $vuetify: {
    ...ja,
  },
}
